var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletConnectLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#6B46FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "url(#paint0_radial_881_13019)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42262 9.20957C9.75075 6.93014 13.5254 6.93014 15.8535 9.20957L16.1337 9.48391C16.2501 9.59788 16.2501 9.78266 16.1337 9.89663L15.1752 10.8351C15.117 10.8921 15.0227 10.8921 14.9644 10.8351L14.5789 10.4576C12.9547 8.86737 10.3214 8.86737 8.69726 10.4576L8.28434 10.8618C8.22614 10.9188 8.13177 10.9188 8.07357 10.8618L7.11508 9.92341C6.99867 9.80943 6.99867 9.62465 7.11508 9.51068L7.42262 9.20957ZM17.8358 11.1504L18.6888 11.9856C18.8052 12.0996 18.8052 12.2843 18.6888 12.3983L14.8423 16.1644C14.7259 16.2784 14.5372 16.2784 14.4208 16.1644C14.4208 16.1644 14.4208 16.1644 14.4208 16.1644L11.6908 13.4915C11.6617 13.463 11.6145 13.463 11.5854 13.4915C11.5854 13.4915 11.5854 13.4915 11.5854 13.4915L8.85545 16.1644C8.73904 16.2784 8.55031 16.2784 8.4339 16.1644C8.4339 16.1644 8.4339 16.1644 8.4339 16.1644L4.5873 12.3983C4.4709 12.2843 4.4709 12.0995 4.5873 11.9855L5.44036 11.1503C5.55677 11.0363 5.7455 11.0363 5.86191 11.1503L8.59195 13.8233C8.62105 13.8518 8.66823 13.8518 8.69734 13.8233C8.69734 13.8233 8.69734 13.8233 8.69734 13.8233L11.4272 11.1503C11.5436 11.0363 11.7324 11.0363 11.8488 11.1503C11.8488 11.1503 11.8488 11.1503 11.8488 11.1503L14.5788 13.8233C14.6079 13.8517 14.6551 13.8517 14.6842 13.8233L17.4142 11.1504C17.5306 11.0364 17.7193 11.0364 17.8358 11.1504Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_881_13019",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 12) scale(24)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectLogo);
export default __webpack_public_path__ + "static/media/WalletConnectLogo.59897a62ce5e24807f6ce2b06672c237.svg";
export { ForwardRef as ReactComponent };